import { render, staticRenderFns } from "./PurchaseRequisition.vue?vue&type=template&id=784dfce8&scoped=true&"
import script from "./PurchaseRequisition.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisition.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisition.vue?vue&type=style&index=0&id=784dfce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784dfce8",
  null
  
)

export default component.exports